import { ApplicationUserStatisticsView } from './../../../../services/users.service';
import { Component, Injector, OnInit } from '@angular/core';
import { BaseAdminPanelComponent } from "../../base-admin-panel/base-admin-panel.component";
import { Observable } from "rxjs";
import { UserViewModel, UserCreateViewModel } from "../../../../services/users.service";
import { ChangePasswordViewModel } from "../users-dialog-base/users-dialog-base.component";
import { CreateUserComponent } from "../create-user.component";
import { EditUserComponent } from "../edit-user.component";
import { CompanyModel } from 'app/services/companies.service';

@Component({
  selector: '[app-users]',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
  standalone: false
})
export class UsersComponent extends BaseAdminPanelComponent implements OnInit {

  companies: CompanyModel[];
  users: ApplicationUserStatisticsView[];
  constructor(protected injector: Injector) {
    super(injector);
  }

  protected Refresh() {
    this.usersService.getUsersStatistics().subscribe(users => {
      this.objects = users;
      this.users = users;
    });
    this.companyService.getCompanies().subscribe(companies => {
      this.companies = companies;
    });
  }

  public openCreateModal() {
    this.prepareModal(CreateUserComponent);
    this.componentRef.instance.users = this.objects;
    this.componentRef.instance.changePasswordModel = new ChangePasswordViewModel();
    let userCreateViewModel = new UserCreateViewModel();
    userCreateViewModel.Acl = 65535;
    this.componentRef.instance.open(userCreateViewModel);
  }


  public openEditModal(user: UserViewModel) {
    this.prepareModal(EditUserComponent);
    this.componentRef.instance.targetUser = user;
    this.componentRef.instance.users = this.objects;
    this.componentRef.instance.changePasswordModel = new ChangePasswordViewModel();
    this.componentRef.instance.open(new UserViewModel());
    this.componentRef.instance.onSubmit.subscribe(() => {
      if (user.Id == this.usersService.getCurrentUser().Id) {
        this.usersService.initializeUser();
        this.syncService.NotifyEntityChanged("User", this.usersService.getCurrentUser().Id);
      }
    });
    this.usersService.getUserDetails(user.Id)
      .subscribe(result => {
        this.componentRef.instance.model = result;
        if (typeof this.componentRef.instance.onModelUpdated === "function") {
          this.componentRef.instance.onModelUpdated();
        }
      });
  }

  protected doDeleteObject(id: number): Observable<any> {
    return this.usersService.deleteUser(id);
  }

  getUserState(user: ApplicationUserStatisticsView) {
    if (user.IsDisabled)
      return this.translate.instant("Blocked");

    //if (user.IsLockedOut)
    //  return this.translate.instant("Temporary blocked");

    if (!user.IsEmailConfirmed)
      return this.translate.instant("Verification");

    return this.translate.instant("Active");
  }
  getCompanyName(user: UserViewModel) {
    return this.companies.find(x => x.Id == user.CompanyId)?.Name ?? "";

  }
  companyFilterChange(companyIds: number[] | null | undefined) {
    this.filter.companyIds = companyIds ?? [];
    this.objects.forEach((obj) => obj.IsChecked = false);
  }
}
